export enum BaseOrderKeyEnum {
  startDate = 'startDate',
  endDate = 'endDate',
  createdAt = 'createdAt',
  profileLastName = 'profileLastName',
  customerName = 'customerName',
  mainQualificationName = 'mainQualificationName',
  pspBranchName = 'pspBranchName',
}
